// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"23e28411","238":"43ad0012","289":"60c816ef","396":"cfbeb469","453":"2112f36d","877":"bfb24685","912":"0d0a4ae3","927":"131c1a92"}[chunkId] + ".chunk.js";
};